import { routes_names } from "@/router/constants";

export const sidebar = [
  {
    text: 'Dashboard',
    icon: 'house-fill',
    to: {
      name: routes_names.main,
    },
  },
  {
    text: 'Filters',
    icon: 'x-circle-fill',
    to: {
      name: routes_names.filters,
    },
  },
  {
    text: 'Thresholds',
    icon: 'x-circle-fill',
    to: {
      name: routes_names.thresholds,
    },
  },
  {
    text: 'Sip Servers',
    icon: 'x-circle-fill',
    to: {
      name: routes_names.sip_servers,
    },
  },
  {
    text: 'Call Hangup Reports',
    icon: 'x-circle-fill',
    to: {
      name: routes_names.call_hangup_reports,
    },
  },
]